import React from 'react';
import { useSelector } from 'react-redux';

const Steps = ({ children }) => {
  const current = useSelector(state => state.stepBuilder.current);
  const steps = React.Children.toArray(children);
  
  return steps[current - 1] || null;
};

export default Steps;